import { useRef } from 'react';
import useExternalScript from '~/hooks/use-external-script.ts';

const loadPaypalScript = ({ src, attributes = {}, innerHTML = '' }) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = src;
		script.innerHTML = innerHTML;
		const attrs = Object.keys(attributes);
		if (attrs.length > 0) {
			attrs.forEach(key => {
				script.setAttribute(key, attributes[key]);
			});
		}
		document.head.appendChild(script);
		script.onload = resolve;
		script.onerror = reject;
	});
};

const paypalScrData = {
	script1: 'https://paypal-fraudnetconfig.com',
	script2: 'https://c.paypal.com/da/r/fb.js',
	fncls: 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99',
	html: `"s":"ComeOn_ZB4TN69EVDAXN_RT",
	"sandbox":"false"`
};

const usePaypalOrderRef = hasPlayerHadBillingAgreementsEver => {
	const OrderFuniquedID = useRef(window.crypto.randomUUID());
	const status = useExternalScript([
		{
			type: 'application/json',
			src: paypalScrData.script1,
			fncls: paypalScrData.fncls,
			innerHTML: `{
				"f":"${OrderFuniquedID.current}",
				${paypalScrData.html} 
			}`,
			option: {
				position: 'head',
				removeOnUnmount: false,
				isReload: true,
				initialLoad: hasPlayerHadBillingAgreementsEver !== 'true'
			}
		},
		{
			type: 'text/javascript',
			src: paypalScrData.script2,
			option: {
				position: 'head',
				removeOnUnmount: false,
				isReload: true,
				initialLoad: hasPlayerHadBillingAgreementsEver !== 'true'
			}
		}
	]);

	return { status, OrderFuniquedID };
};

export default usePaypalOrderRef;

export const loadPaypalScriptAsync = async () => {
	const OrderFuniquedID = window.crypto.randomUUID();
	loadPaypalScript({
		src: paypalScrData.script1,
		attributes: {
			fncls: paypalScrData.fncls,
			type: 'application/json'
		},
		innerHTML: `{
			"f":"${OrderFuniquedID}",
					${paypalScrData.html}
		}`
	});
	await loadPaypalScript({
		src: paypalScrData.script2,
		attributes: {
			type: 'text/javascript'
		}
	});
	return OrderFuniquedID;
};
